import { Modal } from 'bootstrap';

const API = '/umbraco/md/iplogin';

/**
 * IP-Login - wie checkLogin/#accept-ipl in login.js der alten Seite:
 * gehört die IP zu einer Institution, erscheint der Hinweis #ipl-message.
 * "Fortfahren" meldet an, "Abbrechen" fragt in dieser Sitzung nicht mehr.
 * [data-iplogin-logout] (Toolbar) beendet den IP-Login.
 */
export function initIpLogin() {
    document.querySelectorAll('[data-iplogin-logout]').forEach((button) => {
        button.addEventListener('click', async () => {
            await post('logout');
            window.location.reload();
        });
    });

    const element = document.getElementById('ipl-message');
    if (element === null) {
        return;
    }

    let accepted = false;

    element.querySelector('[data-iplogin-accept]')?.addEventListener('click', async () => {
        accepted = true;
        const response = await post('login');
        if (response.ok) {
            window.location.reload();
        } else {
            Modal.getOrCreateInstance(element).hide();
        }
    });

    element.addEventListener('hidden.bs.modal', () => {
        if (!accepted) {
            post('decline');
        }
    });

    fetch(`${API}/check`, { credentials: 'same-origin', cache: 'no-store' })
        .then((response) => (response.ok ? response.json() : null))
        .then((result) => {
            if (result?.available) {
                Modal.getOrCreateInstance(element).show();
            }
        })
        .catch(() => { /* ohne Antwort kein Hinweis */ });
}

function post(action) {
    return fetch(`${API}/${action}`, { method: 'POST', credentials: 'same-origin' });
}
